import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MeasureButton from "../../components/selections/measure/MeasureButton";
import "./selection.css";
import Layout from "../../components/resusable/layout/layout";
import { _userProfileData } from "../../components/https/settings/profileSettings";
import { errorRequestHandel } from "../../helper";
import { _addUserProfileData } from "../../redux/actions/profileSettingsAction";
import { useDispatch } from "react-redux";
import { Col, Row } from "antd";
import {
  getAllCountries,
  getAllDropdownsData,
  getDentalIndentificationMetaData,
  getSiteData,
} from "../../components/https/projects-apis";
import {
  _getCountriesList,
  _getDentalIdentificationDropdowns,
  _getMetaData,
  _getSiteData,
  _setMyOrganizationData,
} from "../../redux/actions/generalAction";
import SelectionSkeleton from "../../dentail-indetifcation/components/skeletons/SelectionSkeleton";
import { dentalIcons } from "../../dentail-indetifcation/utils-icons/dentalIcons";
import { getMyOrganization } from "../../components/https/planSubscriptions";

const Selections = (props) => {
  const [loading, setLoading] = useState(false);
  const basePath = "/dental-identification";
  const ageAssessmentBasePath = "/age-assessment";

  const dispatch = useDispatch();
  useEffect(() => {
    userProfileData();
    getApplicationDropdowns();
    getCountriesListData();
    getMetaData();
    fetchSiteData();
    getMyOrganizations();
  }, []);

  const userProfileData = async () => {
    try {
      const response = await _userProfileData();
      if (response.status === 200) {
        dispatch(_addUserProfileData(response.data.data));
        localStorage.setItem("user", JSON.stringify(response.data.data));
      }
    } catch (error) {
      errorRequestHandel({ error: error });
    }
  };

  const getApplicationDropdowns = async () => {
    try {
      setLoading(true);
      const response = await getAllDropdownsData();
      if (response.status === 200) {
        dispatch(_getDentalIdentificationDropdowns(response.data.data));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error });
    }
  };
  const getCountriesListData = async () => {
    try {
      setLoading(true);
      const response = await getAllCountries();
      if (response.status === 200) {
        const unknownCountry = {
          id: null,
          iso: "unknown",
          iso3: "unknown",
          name: "Unknown",
          nice_name: "Unknown",
          num_code: 0.0,
          phone_code: 0.0,
        };
        const countriesWithUnknownCountry = [
          unknownCountry,
          ...response.data.data,
        ];

        dispatch(_getCountriesList(countriesWithUnknownCountry));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error });
    }
  };
  const getMetaData = async () => {
    try {
      setLoading(true);
      const response = await getDentalIndentificationMetaData();
      if (response.status === 200) {
        dispatch(_getMetaData(response.data.data));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error });
    }
  };
  const fetchSiteData = async () => {
    try {
      setLoading(true);
      const response = await getSiteData();
      if (response.status === 200) {
        dispatch(_getSiteData(response.data.data));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error });
    }
  };

  const getMyOrganizations = async () => {
    try {
      setLoading(true);
      const resposen = await getMyOrganization();
      if (resposen.status === 200) {
        dispatch(_setMyOrganizationData(resposen.data.data));
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      errorRequestHandel({ error });
    }
  };

  return (
    <Layout>
      {loading ? (
        <SelectionSkeleton />
      ) : (
        <div className="measure-container">
          <Row gutter={[5, 20]}>
            {/* <Col
              xl={6} // 4 columns on large screens
              lg={8} // 3 columns on medium screens
              md={12} // 2 columns on small screens
              sm={24} // 1 column on mobile
              xs={24}
            >
              <Link to="/length-measurement">
                <MeasureButton
                  title={`Linear \n Measurement`}
                  icon={dentalIcons.linearIcon}
                />
              </Link>
            </Col> */}
            {/* <Col
              xl={6} // 4 columns on large screens
              lg={8} // 3 columns on medium screens
              md={12} // 2 columns on small screens
              sm={24} // 1 column on mobile
              xs={24}
            >
              <Link to="/area-measurement">
                <MeasureButton
                  title={`Polygon \n Measurement`}
                  icon={dentalIcons.polygonIcon}
                />
              </Link>
            </Col> */}
            <Col
              xl={6} // 4 columns on large screens
              lg={8} // 3 columns on medium screens
              md={12} // 2 columns on small screens
              sm={24} // 1 column on mobile
              xs={24}
            >
              <Link to={`${ageAssessmentBasePath}/dashboard`}>
                <MeasureButton
                  title={`Age \n Assessment`}
                  icon={dentalIcons.ageAssessmentIcon}
                />
              </Link>
            </Col>
            <Col
              xl={6} // 4 columns on large screens
              lg={8} // 3 columns on medium screens
              md={12} // 2 columns on small screens
              sm={24} // 1 column on mobile
              xs={24}
            >
              <Link to={`/dental-analysis/projects`}>
                <MeasureButton
                  title={`Dental \n Analysis`}
                  icon={dentalIcons.ageAssessmentIcon}
                />
              </Link>
            </Col>
            <Col
              xl={6} // 4 columns on large screens
              lg={8} // 3 columns on medium screens
              md={12} // 2 columns on small screens
              sm={24} // 1 column on mobile
              xs={24}
            >
              <Link to={`${basePath}/dashboard`}>
                <MeasureButton
                  title={`Dental \n Indentification`}
                  icon={dentalIcons.identificationIcon}
                />
              </Link>
            </Col>
            <Col
              xl={6} // 4 columns on large screens
              lg={8} // 3 columns on medium screens
              md={12} // 2 columns on small screens
              sm={24} // 1 column on mobile
              xs={24}
            >
              <Link to="/ai-measurement">
                <MeasureButton
                  title={`Second \n Opinion`}
                  icon={dentalIcons.secondOpinion}
                />
              </Link>
            </Col>
          </Row>
        </div>
      )}
      {/* <Link to={subscriptionPath}>
        <CustomPrimaryButton title="Subscriptions" />
      </Link> */}
    </Layout>
  );
};

export default Selections;
